export default __webpack_public_path__ + "static/media/colored-route.091f0d47.svg";